

import CommonApi from './../commonApi';

const budgetsForAnalysis = new CommonApi(
  'budgetForAnalysis',
  'Бюджеты для анализа'
);

export default {
  ...budgetsForAnalysis
};
